export const AuctionStatusType = {
  PHYSICAL: 'PHYSICAL',
  MINIMUM_PRICE: 'MINIMUM_PRICE',
  TRYING_TO_DEAL: 'TRYING_TO_DEAL',
  BUY_NOW_ONLY: 'BUY_NOW_ONLY',
};

export const AuctionStatusTypeName = {
  PHYSICAL: 'Reserve Price',
  MINIMUM_PRICE: 'No Reserve',
  TRYING_TO_DEAL: 'Trying to Deal',
  BUY_NOW_ONLY: 'Buy Now Only',
};
